export default "__VITE_ASSET__Ds4EI5J3__"